import {UI} from "../../../stem-core/src/ui/UIBase";
import {ConfirmationModal} from "../../../blinkpay/ui/ConfirmationModal";
import {BlinkInput} from "../../../blinkpay/ui/Input";
import {wrapInSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {
    apiMerchantCreateEmailSender
} from "../../../client/state/merchant/MerchantEmailSender";


export class MerchantAddEmailSenderModal extends ConfirmationModal {
    inputRefs = {};

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: "Add new email sender",
            description: "Will create an email sender entry which you can use to send emails to your audiences",
            confirmLabel: "Confirm",
            confirmAction: () => this.addEmailSender(),
        };
    }

    validateInputs() {
        let isValid = true;

        for (const [key, fieldInput] of Object.entries(this.inputRefs)) {
            fieldInput.validate();
            isValid = isValid && fieldInput.isValid();
        }

        return isValid;
    }

    @wrapInSpinner
    async addEmailSender() {
        if (!this.validateInputs()) {
            return;
        }
        const request = {
            emailAddress: this.inputRefs.emailInput.getValue().trim(),
            name: this.inputRefs.nameInput.getValue().trim(),
        }

        await apiMerchantCreateEmailSender(request);
        this.hide();
    }

    render() {
        return <div>
            <BlinkInput ref={{parent: this.inputRefs, name: "emailInput"}}
                        label={"Email"}
                        inputAttributes={{placeholder: "Email"}}
                        validators={[{condition: () => !this.inputRefs.emailInput.isEmpty()}]}
            />
            <BlinkInput ref={{parent: this.inputRefs, name:"nameInput"}}
                        label={"Name (Optional)"}
                        inputAttributes={{placeholder: "Name"}}
            />
        </div>
    }
}
